import React from 'react';
import { Helmet } from 'react-helmet-async';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TwitterMeta = _ref => {
  let {
    description,
    image,
    title
  } = _ref;
  return /*#__PURE__*/_jsxs(Helmet, {
    prioritizeSeoTags: true,
    children: [/*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: "summary"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:site",
      content: "@AtlassianMarket"
    }), description ? /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: description
    }) : null, image ? /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: image
    }) : null, title ? /*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: title
    }) : null]
  });
};
export default TwitterMeta;